import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import Tab from "react-bootstrap/Tab";
import { Container, Row, Col, Table } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import LeftAdministration from "./LeftAdministration";

function Main() {

  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Administration" />
      <section className="project-detail">
        <div className="container">
          <div className="section-title center-align mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s" >
            <h5><i className="fal fa-graduation-cap" /> Administration</h5>
            <h2>Board of Governors</h2>
          </div>
          <Row>
            <Col md={4} className="c-left">
              <LeftAdministration activeIndex={0} />
            </Col>

            <Col md={8} className="c-left">
              <table className="table table-striped">
                <tbody className="c-lineheight2 ">
                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <Link
                          to="https://iittp.ac.in/bog-chairman"
                          target="_blank;"
                        >
                          <b>Shri Sajjan Jindal</b>
                        </Link>
                        <br />
                        Chairman &amp; Managing Director
                        <br />
                        JSW Group <br /> <i className="uk-icon-firefox"></i>
                        <Link
                          to="https://iittp.ac.in/bog-chairman"
                          target="_blank;"
                        >
                          Brief Biodata
                        </Link>
                      </div>
                    </td>
                    <td>

                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/Sajjan Jindal_BoG_Chairman.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b> Chairman</b></p>
                        </div>
                      </div>

                    </td>
                  </tr>
                  <tr>
                    <td className="align-middle ">
                      <div className="ms-3">
                      <Link
                          to="https://iittp.ac.in/director"
                          target="_blank;">
                        <b>Prof. K. N. Satyanarayana</b>
                        </Link>                        <br />
                        Director, IIT Tirupati
                        <br />
                        Tirupati - 517619<br />
                        <Link
                          to="https://iittp.ac.in/director"
                          target="_blank;"
                        >
                          Read More..
                        </Link>
                      </div>
                    </td>

                    <td>

                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                           <img src="https://files.iittp.ac.in/images/demo/iit/director.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b> Ex-Officio Member</b></p>
                        </div>
                      </div>
                    </td>

                  </tr>
                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <b>The Principal Secretary to the Government,</b>
                        <br />
                        Higher Education Department,
                        <br />
                        Andhra Pradesh.
                      </div>
                    </td>
                    <td>
                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/noimages.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>

                  </tr>

                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <b>Shri G. Yoganand</b>
                        <br />
                        Chairman &amp; Managing Director, Manjeera Constructions
                        Ltd
                        <br />
                        Hyderabad – 500 038
                      </div>
                    </td>
                    <td>  <div className="team-thumb-sm  mt-1 text-center">
                      <div className="brd">
                        <a href="#">

                          <img src="https://files.iittp.ac.in/images/demo/iit/noimages.png" alt="image"></img>
                        </a>
                        <p className="text-center "><b>Member</b></p>
                      </div>
                    </div></td>
                  </tr>
                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <b>Prof. K. Srinivas Reddy</b> 
                        <br />
                        Professor, Department of Mechanical Enginnering, IIT
                        Madras
                        <br />
                        Chennai – 600 036
                      </div>
                    </td>
                    <td>
                      
                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/bog/Dr.SrinivasaReddy.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                      </td>
                  </tr>
                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                       <b> Additional Secretary (TE) / Joint Secretary (dealing with
                          IITs), MHRD <br /></b>
                        Shastri Bhavan, New Delhi – 110015
                      </div>
                    </td>
                    <td>
                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/noimages.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div></td>
                  </tr>
                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <b>Shri M. Raja Mahender Reddy</b>
                        <br />
                        Managing Director, M/s. Venkateswara Pesticides &amp;
                        Allied Chemicals Pvt Ltd
                        <br />
                        Banjara Hills, Hyderabad – 500 034
                      </div>
                    </td>
                    <td>
                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/noimages.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                      </td>
                  </tr>
                  <tr>

                    <td className="align-middle">
                      <div className="ms-3">
                        <b> Prof. KSMS Raghavarao </b>
                        <br />
                        Professor, Department of Chemical Engineering, IIT
                        Tirupati
                        <br />
                        Tirupati – 517619
                      </div>
                    </td>
                    <td>
                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/raghavarao.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>

                    </td>
                  </tr>
                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <b> Prof. Sasidhar Gumma</b>
                        <br />
                        Professor, Department of Chemical Engineering , IIT
                        Tirupati
                        <br />
                        Tirupati – 517619
                      </div>
                    </td>
                    <td>

                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/SG.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member</b></p>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <b>Prof. Santanu Bhattacharya</b>
                        <br />
                        Director, IISER Tirupati
                        <br />
                        Tirupati – 517507
                      </div>
                    </td>
                    <td>
                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/bog/Prof_Santanu.png" alt="image"></img>
                          </a>
                          <p className="text-center "><b> Special Invitee</b></p>
                        </div>
                      </div>

                     </td>
                  </tr>

                  <tr>
                    <td className="align-middle">
                      <div className="ms-3">
                        <b>Shri Sumit Kumar Biswas</b>
                        <br />
                        Registrar, IIT Tirupati
                        <br />
                        Tirupati – 517619
                      </div>
                    </td>
                    <td>

                      <div className="team-thumb-sm  mt-1 text-center">
                        <div className="brd">
                          <a href="#">

                            <img src="https://files.iittp.ac.in/images/demo/iit/registrar.jpg" alt="image"></img>
                          </a>
                          <p className="text-center "><b>Member Secretary</b></p>
                        </div>
                      </div>
                      
                      </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
}

export default Main;
